// Maps proficiency string (Languages or Skills) to a numeric value (1-5)
export function getProficiencyValue(proficiency) {
  if (!proficiency) return 0;
  const lowerProficiency = proficiency.toLowerCase();

  // Language levels
  if (lowerProficiency.includes("native") || lowerProficiency.includes("bilingual")) return 5;
  if (lowerProficiency.includes("fluent")) return 5;
  if (lowerProficiency.includes("advanced")) return 4;
  if (lowerProficiency.includes("intermediate")) return 3;
  if (lowerProficiency.includes("basic")) return 2;
  if (lowerProficiency.includes("beginner")) return 1;

  // Skill levels
  if (lowerProficiency === "expert") return 5;

  // Fallback
  return 0;
} 